import store from "../services/store"
import { isEmpty } from "../libs/validation/validators";
import { usePost, useGet } from "../libs/service/api";
var initialData = {
    "username": "",
    "email": "",
    "userid": 0,
    "needsassesmentid": 0,
    "passwordexist":0
}
var setUserData = (data) => {
    console.log(data)
    if (isEmpty(data)) {
        data = initialData;
    }
    store.api.setJSON(store.data.USERDATA, data);
}
var getUserData = () => {
    var json = store.api.getJSON(store.data.USERDATA)
    if (isEmpty(json)) {
        json = initialData
    }
    return json;
}

export default {
    clearData: () => {
        store.api.clearItem(store.data.OTPData);
    },
    setUserData: (data) => {
        setUserData(data);
    },
    getUserData: () => {
        return getUserData();
    },
}